export const useNativeClientService = () => {
  function attemptIosMessagePost<P>(
    type:
      | 'closeScreen'
      | 'readyForCommunication'
      | 'openImage'
      | 'showUpgradeDialog'
      | 'openExternalLink',
    payload?: P,
    payloadVersion: number = 1
  ) {
    if (typeof window === 'undefined' || !window.webkit?.messageHandlers?.iOSMessageHandler) {
      return false
    }

    window.webkit.messageHandlers.iOSMessageHandler.postMessage(
      JSON.stringify({
        type,
        payload: payload ?? null,
        payload_version: payloadVersion
      })
    )

    if (!payload) {
      // send event without payload
      window.webkit.messageHandlers.iOSMessageHandler.postMessage(type)
    }

    return true
  }

  function showUpgradeDialog() {
    if (typeof window !== 'undefined' && typeof window?.Android !== 'undefined') {
      window.Android.showUpgradeDialog()

      return true
    } else if (attemptIosMessagePost('showUpgradeDialog')) {
      return true
    }

    return false
  }

  function closeScreen() {
    if (typeof window !== 'undefined' && typeof window?.Android !== 'undefined') {
      window.Android.closeScreen()

      return true
    } else if (attemptIosMessagePost('closeScreen')) {
      return true
    }

    return false
  }

  function openImage(url: string) {
    if (typeof window !== 'undefined' && typeof window?.Android !== 'undefined') {
      window.Android.openImage(url)

      return true
    } else if (attemptIosMessagePost('openImage', url)) {
      return true
    }

    return false
  }

  function openExternalLink(url: string) {
    if (typeof window !== 'undefined' && typeof window?.Android !== 'undefined') {
      window.Android.openExternalLink(url)

      return true
    } else if (attemptIosMessagePost('openExternalLink', url)) {
      return true
    }

    return false
  }

  function readyForCommunication() {
    if (typeof window !== 'undefined' && typeof window.Android !== 'undefined') {
      window.Android.readyForCommunication()

      return true
    } else if (attemptIosMessagePost('readyForCommunication')) {
      return true
    }

    return false
  }

  function supportsTrueNativeShare() {
    return (
      typeof navigator !== 'undefined' &&
      typeof navigator.share !== 'undefined' &&
      typeof navigator.canShare !== 'undefined'
    )
  }

  function supportsAndroidNativeShare() {
    return (
      typeof window !== 'undefined' &&
      typeof window.Android !== 'undefined' &&
      typeof window.Android.nativeShare !== 'undefined'
    )
  }

  function nativeShare(title: string, text: string, url: string) {
    if (supportsTrueNativeShare() && navigator.canShare({ title, text, url })) {
      navigator.share({
        title,
        text,
        url
      })

      return true
    } else if (typeof window !== 'undefined' && typeof window.Android !== 'undefined') {
      window.Android.nativeShare(title, text, url)

      return true
    }

    return false
  }

  return {
    attemptIosMessagePost,
    showUpgradeDialog,
    closeScreen,
    openImage,
    openExternalLink,
    readyForCommunication,
    supportsTrueNativeShare,
    supportsAndroidNativeShare,
    nativeShare
  }
}
